// created from 'create-ts-index'

export * from './supplier-master.model';
export * from './supplier-master-type.model';
